import { Model } from '@/models/Model';
export class Treatment extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Treatment';
        this.$endpoint = '/treatments';
        this.$fillable = ['description'];
    }
    updateTreatment(payload) {
        const url = this.$endpoint;
        return this.request('put', url, payload);
    }
}
